import $vuetify from 'vuetify/es5/locale/en';

export default {
  $vuetify,
};
